import { setAccessToken, getAccessToken, deleteAccessToken } from '@driftt/web-auth'

const DEVELOPER_TOKEN_KEY = 'drift.dev.tkn'

export const setDriftToken = (token) => setAccessToken({ token })

export const getDriftToken = () => getAccessToken()

export const removeDriftToken = () => deleteAccessToken()

export const setDeveloperToken = (token) => {
  window.localStorage.setItem(DEVELOPER_TOKEN_KEY, token)
}

export const getDeveloperToken = (token) => {
  return window.localStorage.getItem(DEVELOPER_TOKEN_KEY)
}

export const removeDeveloperToken = () => {
  window.localStorage.removeItem(DEVELOPER_TOKEN_KEY)
}

export const removeAllTokens = () => {
  removeDriftToken()
  removeDeveloperToken()
}

export const hasTokens = () => {
  return !!getDriftToken() && !!getDeveloperToken()
}
